'use client';

import { c as _c } from "react/compiler-runtime";
import { useLocale } from 'next-intl';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { LOCALE_CONFIG } from '@/i18n/config';
import { getLocaleDir } from '@/i18n/locale';
import { usePathname, useRouter } from '@/i18n/navigation';
import { type Locale, routing } from '@/i18n/routing';
import { updateUserLocale } from '@/services/user-locale';
interface LocaleSelectorProps {
  userId?: string;
}
export function LocaleSelector(t0) {
  const $ = _c(16);
  const {
    userId
  } = t0;
  const locale = useLocale() as Locale;
  let t1;
  if ($[0] !== locale) {
    t1 = getLocaleDir(locale);
    $[0] = locale;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const dir = t1;
  const router = useRouter();
  const pathname = usePathname();
  const currentConfig = LOCALE_CONFIG[locale];
  let t2;
  if ($[2] !== pathname || $[3] !== router || $[4] !== userId) {
    t2 = function handleLocaleChange(newLocale) {
      router.replace(pathname, {
        locale: newLocale
      });
      if (userId) {
        updateUserLocale(userId, newLocale);
      }
    };
    $[2] = pathname;
    $[3] = router;
    $[4] = userId;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleLocaleChange = t2;
  let t3;
  if ($[6] !== currentConfig.flag) {
    t3 = <DropdownMenuTrigger id="tour-locale-selector" className="size-8 rounded-full border border-border bg-background text-xl hover:bg-muted hover:text-foreground aria-expanded:bg-muted aria-expanded:text-foreground dark:border-input dark:bg-input/30 dark:hover:bg-input/50">{currentConfig.flag}</DropdownMenuTrigger>;
    $[6] = currentConfig.flag;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== handleLocaleChange) {
    t4 = routing.locales.map(l => <DropdownMenuItem key={l} onClick={() => handleLocaleChange(l)}><span className="mr-2">{LOCALE_CONFIG[l].flag}</span>{LOCALE_CONFIG[l].name}</DropdownMenuItem>);
    $[8] = handleLocaleChange;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = <DropdownMenuContent>{t4}</DropdownMenuContent>;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== dir || $[13] !== t3 || $[14] !== t5) {
    t6 = <DropdownMenu dir={dir}>{t3}{t5}</DropdownMenu>;
    $[12] = dir;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}